import React from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import { Draggable } from 'react-beautiful-dnd';
import { BsTrash } from 'react-icons/bs';

import * as Styled from '../../containers/FormRetrospective/style';

const getStyle = (style, snapshot) => {
  if (!snapshot.isDropAnimating) {
    return style;
  }
  return {
    ...style,
    // cannot be 0, but make it super tiny
    transitionDuration: `0.001s`,
  };
};

function DraggableCustomFormat({ displayText, element, index, removeElement }) {
  return (
    <Draggable
      key={`${element.id}key`}
      draggableId={`${element.id}`}
      index={index}
    >
      {(provided, snapshot) => (
        <Styled.RelativeContainer
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          isDragging={snapshot.isDragging}
          ref={provided.innerRef}
          style={getStyle(provided.draggableProps.style, snapshot)}
        >
          <span>
            <GiHamburgerMenu />
          </span>

          <span>{displayText}</span>

          <Styled.FloatButton
            type="button"
            fontSize={1}
            onClick={() => removeElement(element)}
          >
            <BsTrash />
          </Styled.FloatButton>
        </Styled.RelativeContainer>
      )}
    </Draggable>
  );
}

export default DraggableCustomFormat;
